import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Dashboard 页面固定状态管理 Store
 * 用于控制 dashboard 外层容器的滚动行为
 */
export const useDashboardPageFixStore = defineStore('dashboard-page-fix', () => {
  const isPageFix = ref(false)

  /**
   * 设置页面固定状态
   * @param value 是否固定页面（禁用外层滚动）
   */
  function setPageFix(value: boolean) {
    isPageFix.value = value
  }

  /**
   * 启用页面固定（禁用外层滚动）
   */
  function enable() {
    setPageFix(true)
  }

  /**
   * 禁用页面固定（恢复外层滚动）
   */
  function disable() {
    setPageFix(false)
  }

  return {
    isPageFix,
    setPageFix,
    enable,
    disable
  }
})
